import React from 'react';
import { Route } from 'react-router-dom';
import Books from '@/pages/library/Books';
import BooksReports from '@/pages/library/BooksReports';
import AuthorEntry from '@/pages/library/AuthorEntry';
import CategoryEntry from '@/pages/library/CategoryEntry';
import PublishersEntry from '@/pages/library/PublishersEntry';
import RackEntry from '@/pages/library/RackEntry';
import IssueBook from '@/pages/library/IssueBook';
import ReturnBook from '@/pages/library/ReturnBook';
import IssuedBooks from '@/pages/library/IssuedBooks';
import AddMember from '@/pages/library/AddMember';
import MemberList from '@/pages/library/MemberList';
import DamagedBooks from '@/pages/library/DamagedBooks';
import FineReport from '@/pages/library/FineReport';
import AccessionRegister from '@/pages/library/AccessionRegister';

export const libraryRoutes = (
  <React.Fragment>
    <Route path="library/books" element={<Books />} />
    <Route path="library/books-reports" element={<BooksReports />} />
    <Route path="library/accession-register" element={<AccessionRegister />} />
    <Route path="library/author-entry" element={<AuthorEntry />} />
    <Route path="library/category-entry" element={<CategoryEntry />} />
    <Route path="library/publishers-entry" element={<PublishersEntry />} />
    <Route path="library/rack-entry" element={<RackEntry />} />
    <Route path="library/issue-book" element={<IssueBook />} />
    <Route path="library/return-book" element={<ReturnBook />} />
    <Route path="library/issued-books" element={<IssuedBooks />} />
    <Route path="library/add-member" element={<AddMember />} />
    <Route path="library/member-list" element={<MemberList />} />
    <Route path="library/damaged-books" element={<DamagedBooks />} />
    <Route path="library/fine-report" element={<FineReport />} />
  </React.Fragment>
);
